import React, { useCallback, useMemo, useState } from 'react';
import { FOOTER_VIEW_APPS, FOOTER_VIEW_MARKETPLACE, type FooterView } from './AppsFooter.constants';
import { AppsFooterContext } from './useAppsFooter';
import { useAppsFooterState } from './useAppsFooterState';

/** Lets a page open the footer, e.g. the Skills page sending the user to the marketplace. */
const AppsFooterProvider: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  const { open, expanded, setOpen, setExpanded } = useAppsFooterState();
  const [view, setView] = useState<FooterView>(FOOTER_VIEW_APPS);

  const showMarketplace = useCallback(() => {
    setView(FOOTER_VIEW_MARKETPLACE);
    setOpen(true);
  }, [setOpen]);

  const value = useMemo(
    () => ({ open, expanded, view, setOpen, setExpanded, setView, showMarketplace }),
    [open, expanded, view, setOpen, setExpanded, showMarketplace],
  );

  return <AppsFooterContext.Provider value={value}>{children}</AppsFooterContext.Provider>;
};

export default AppsFooterProvider;
